import { createContext, useContext, useEffect, useState } from "react"
import { api, getToken, setToken } from "../api/client"

const Ctx = createContext(null)

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null)
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState(true)

  // Función para refrescar la sesión y las empresas
  const refreshSession = async () => {
    if (!getToken()) return
    try {
      const [me, comps] = await Promise.all([
        api.getMe().catch(() => null),
        api.myCompanies().catch(() => null),
      ])
      if (me && me.user) {
        localStorage.setItem("user", JSON.stringify(me.user))
        setUser(me.user)
      }
      if (comps && comps.companies) {
        setCompanies(comps.companies)
      }
    } catch (_) { }
  }

  useEffect(() => {
    const raw = localStorage.getItem("user")
    const token = getToken()
    if (!raw || !token) {
      setLoading(false)
      return
    }
    try { setUser(JSON.parse(raw)) } catch (_) {}

    let cerrado = false
    const cerrar = () => { if (!cerrado) { cerrado = true; setLoading(false) } }
    const fallbackTimer = setTimeout(cerrar, 3000)

    Promise.all([
      api.getMe().catch(() => null),
      api.myCompanies().catch(() => null),
    ])
      .then(([me, comps]) => {
        if (me && me.user) {
          localStorage.setItem("user", JSON.stringify(me.user))
          setUser(me.user)
        }
        if (comps && comps.companies) {
          setCompanies(comps.companies)
        }
      })
      .finally(() => {
        clearTimeout(fallbackTimer)
        cerrar()
      })
  }, [])

  // FIX: Auto-sincronización cuando el usuario regresa a la pestaña
  useEffect(() => {
    const handleFocus = () => { refreshSession() }
    const handleVisibility = () => { if (document.visibilityState === "visible") refreshSession() }

    window.addEventListener("focus", handleFocus)
    document.addEventListener("visibilitychange", handleVisibility)
    return () => {
      window.removeEventListener("focus", handleFocus)
      document.removeEventListener("visibilitychange", handleVisibility)
    }
  }, [])

  const loginBiometric = (userData, token) => {
    setToken(token)
    localStorage.setItem("user", JSON.stringify(userData))
    setUser(userData)
    api.myCompanies()
      .then((r) => { if (r && r.companies) setCompanies(r.companies) })
      .catch(() => { })
    return userData
  }

  const switchCompany = async (companyId) => {
    const r = await api.switchCompany(companyId)
    if (r && r.token) {
      setToken(r.token)
      const me = await api.getMe()
      if (me && me.user) {
        localStorage.setItem("user", JSON.stringify(me.user))
        setUser(me.user)
      }
      const comps = await api.myCompanies().catch(() => null)
      if (comps && comps.companies) setCompanies(comps.companies)
    }
    return r
  }

  const createCompany = async (data) => {
    const r = await api.createCompany(data)
    if (r && r.token) {
      setToken(r.token)
      const me = await api.getMe()
      if (me && me.user) {
        localStorage.setItem("user", JSON.stringify(me.user))
        setUser(me.user)
      }
      const comps = await api.myCompanies().catch(() => null)
      if (comps && comps.companies) setCompanies(comps.companies)
    }
    return r
  }

  const refreshUser = async () => {
    const me = await api.getMe()
    if (me && me.user) {
      localStorage.setItem("user", JSON.stringify(me.user))
      setUser(me.user)
    }
    return me
  }

  const logout = async () => {
    try { await api.logoutBackend() } catch (_) { }
    setToken(null)
    localStorage.removeItem("user")
    setUser(null)
    setCompanies([])
  }

  return (
    <Ctx.Provider value={{ user, companies, loading, loginBiometric, logout, switchCompany, createCompany, refreshUser, refreshSession }}>
      {children}
    </Ctx.Provider>
  )
}

export const useAuth = () => useContext(Ctx)
